import React from "react";
import PropTypes from "prop-types";
import {WaitingListViewItem} from "./WaitingListViewItem";
import {WaitingListItemObject} from "./WaitingListItemObject";
import moment from "moment";
import {FaSolidIcon} from "../../FontAwesomeIcons";

export class WaitingListView extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isExpanded: false
        }
    }


    handleExpand = _ => {
        this.setState({isExpanded: true});
        if (this.props.waitingList.length <= 0) {
            this.props.onChange([new WaitingListItemObject(moment().format("YYYY-MM-DD"), "09:00", "13:00")])
        }
    }

    handleCollapse = _ => {
        this.props.onChange([]);
        this.setState({isExpanded: false});
    }

    handleChange = idx => wl => {
        const newwaitingList = [...this.props.waitingList];
        newwaitingList[idx] = wl;
        this.props.onChange(newwaitingList);
    }

    handleDelete = idx => _ => {
        const newwaitingList = [...this.props.waitingList];
        newwaitingList.splice(idx, 1);
        this.props.onChange(newwaitingList);
    }

    handleAddNew = _ => {
        const newwaitingList = [...this.props.waitingList];
        newwaitingList.push(new WaitingListItemObject(moment().format("YYYY-MM-DD"), "09:00", "13:00"));
        this.props.onChange(newwaitingList);
    }

    render() {
        return (
            <React.Fragment>
                {
                    !this.state.isExpanded &&
                    <div
                        className={"text-center mt-3 bg-soft-primary p-3 border border-primary"}>
                        <b>Non è il giorno o l'ora che speravi?</b>
                        <button className={"btn btn-sm btn-primary mt-2"} onClick={this.handleExpand}>
                            Unisciti alla lista di attesa
                        </button>
                    </div>
                }
                {
                    this.state.isExpanded &&
                    <React.Fragment>
                        <b className={"text-on-bg-main"}>Lista di attesa</b>
                        <div className={"bg-main-z3 rounded p-3 shadow-sm mt-3"}>
                            <div className={"small text-muted mb-2"}>
                                Seleziona la data e la fascia oraria che preferiresti e ricevi un'avviso se si libera un
                                posto per questa prenotazione
                            </div>
                            {
                                this.props.waitingList.length > 0 &&
                                <div className={"row"}>
                                    <div className={"col-5 pr-1 small"}><b>Data</b></div>
                                    <div className={"col-7 pr-1 small"}><b>Fascia oraria</b></div>
                                </div>
                            }
                            {
                                this.props.waitingList.map((wl, idx) =>
                                    <WaitingListViewItem
                                        key={idx}
                                        waitingList={wl}
                                        onChange={this.handleChange(idx)}
                                        onDelete={this.handleDelete(idx)}
                                    />
                                )
                            }
                            {
                                this.props.waitingList.length >= 3 &&
                                <div className={"text-primary small my-2"}>
                                    <FaSolidIcon name={"exclamation-triangle"}/> Puoi metterti in attesa su massimo 3 fasce orarie
                                </div>
                            }
                            <div className={"d-flex flex-nowrap align-items-center justify-content-between"}>
                                <button className={"btn btn-sm btn-link text-muted"} onClick={this.handleCollapse}>
                                    Annulla
                                </button>
                                <button className={"btn btn-sm btn-link"} onClick={this.handleAddNew} disabled={this.props.waitingList.length >= 3}>
                                    Aggiungi data
                                </button>
                            </div>

                        </div>
                    </React.Fragment>
                }

            </React.Fragment>
        )
    }

}

WaitingListView.propTypes = {
    waitingList: PropTypes.arrayOf(PropTypes.instanceOf(WaitingListItemObject))
}
